<template>
  <v-card flat>
    <v-card-text>Loggar in dig...</v-card-text>
  </v-card>
</template>

<script>
import API from '@/services/api'
import {mapActions, mapGetters} from 'vuex'
// @group Common
// LoginReturn component
export default {
  name: 'LoginReturn',
  data: () => ({
    session: null
  }),
  props: {
    guide: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    ...mapActions('currentuser', ['setCurrentUser'])
  },
  /**
   * @vuese
   * Used to loggin with bank id
   * @arg The argument is an integer representing session id
   */
  created() {
    if (this.guide == true) {
      this.$nextTick(() => {
            this.$router.push({name: 'Start', params: {guide: true}})
          })
    } else {
      this.session = this.$route.query.grandidsession

      API.bankIdLogin({sessionId: this.session})
        .then(res => {
          /**
           * @vuese
           * Used set current user to local store
           * @arg The argument is an object representing current user
           */
          return this.setCurrentUser(res.data)
        })
        .catch(err => {
          if (err.response && err.response.data) {
            this.$events.fire('showError', 'Ett fel uppstod (' + err.response.data + '), om detta händer igen v.v. kontakta BYN:s kansli.')            
          }
        })
        .finally(() => {          
          this.$nextTick(() => {
            this.$router.push({name: 'Start', params: {guide: false}})
          })
        })
    }
  }
}
</script>

<style>
</style>